module.exports = __webpack_public_path__ + "static/media/iconDaily.4c9482c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconDaily.svg
// module id = 208
// module chunks = 0